/// <amd-module name="Search/Package/Components/Results" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { ActionCreator } from "Search/Package/Flux/ActionCreator";
import { FilterPaneContainer } from "Search/Package/Components/FilterPaneContainer";
import { OverlayContainer } from "Search/Package/Components/Overlay";
import { ZeroDataContainer } from "Search/Package/Components/ZeroData";
import { StoresHub, IAggregatedState, StoreName } from "Search/Package/Flux/StoresHub"
import { SearchResultsList } from "Search/Package/Components/SearchResultsList";

export const ResultsContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    ["searchStore"],
    ({ searchStoreState }, props) => {
        return (
            <div className="search-view-container flex-column flex-grow">
                <FilterPaneContainer {...props} />
                <div className="package-search-results flex-column flex-grow relative">
                    <OverlayContainer {...props} />
                    <ZeroDataContainer {...props} />
                    <SearchResultsList
                        pageContext={props.pageContext}
                        actionCreator={props.actionCreator}
                        searchStoreState={searchStoreState}
                        isHosted={props.isHosted}
                    />
                </div>
            </div>
        );
    });
